class QuickBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)

    setTimeout(() => {
      this.listeners.add(document, 'click', this.handleTrigger)

      this.els?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })

      this.externalEls?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })

      this.listeners.add(document, 'click', this.handleFormSubmit)

      document.addEventListener('back-in-stock-open', this.handleClose)
    }, 500)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    )

    if (!trigger) return

    this.externalEls.modal.element.showModal()

    await window.BAO.sectionRenderer
      .fetchSingle('quick-buy', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.qb-Body')

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'quick-buy'

        this.applyRecommendationContext(trigger)
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }

  handleFormSubmit (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="submit"]',
    )

    if (!trigger) return

    this.trackRecommendedQuickBuy(trigger)

    this.externalEls.modal.element.close()
  }

  applyRecommendationContext (trigger) {
    const cartButton = this.els.body.element.querySelector(
      '[data-quick-buy-external-el="submit"]',
    )

    if (!cartButton) {
      return
    }

    const recommendationContext = this.getRecommendationContext(trigger)

    if (!recommendationContext) {
      cartButton.removeAttribute('data-cnstrc-recommendation')
      return
    }

    cartButton.setAttribute(
      'data-cnstrc-recommendation',
      JSON.stringify(recommendationContext),
    )
  }

  getRecommendationContext (trigger) {
    const productData = this.getTriggerProductData(trigger)

    if (!productData?.podId || !productData?.productId) {
      return null
    }

    return {
      itemId: productData.productId,
      itemName:
        trigger.dataset.productTitle ||
        productData.itemName ||
        productData.productId,
      numResultsPerPage: productData.numResultsPerPage,
      podId: productData.podId,
      resultCount: productData.resultCount,
      resultId: productData.result_id,
      resultPage: productData.resultPage,
      resultPositionOnPage: productData.resultPositionOnPage,
      seedItemIds: productData.seedItemIds,
      strategyId: productData.strategyId,
    }
  }

  getTriggerProductData (trigger) {
    const card = trigger.closest('product-card, push-cart-product-card')
    const propData = card?.getAttribute('data-prop-data')

    if (!propData) {
      return null
    }

    try {
      return JSON.parse(propData)
    } catch (error) {
      console.error('Invalid quick buy product data', error)
      return null
    }
  }

  trackRecommendedQuickBuy (trigger) {
    const recommendationContext = this.parseRecommendationContext(trigger)

    if (!recommendationContext || !this.tracker) {
      return
    }

    const conversionData = this.getConversionData(recommendationContext)

    if (!conversionData.itemId) {
      return
    }

    this.tracker.trackRecommendationClick({
      ...recommendationContext,
      ...conversionData,
      section: 'Products',
    })

    this.tracker.trackConversion(undefined, {
      ...conversionData,
      section: 'Products',
      type: 'add_to_cart',
    })
  }

  parseRecommendationContext (trigger) {
    const recommendationContext = trigger.getAttribute(
      'data-cnstrc-recommendation',
    )

    if (!recommendationContext) {
      return null
    }

    try {
      return JSON.parse(recommendationContext)
    } catch (error) {
      console.error('Invalid Constructor recommendation context', error)
      return null
    }
  }

  getConversionData (recommendationContext) {
    const formColumn = this.els.body.element.querySelector(
      '.qb-Body_Column-form',
    )
    const variationInput =
      this.els.body.element.querySelector('input[name="id"]')
    const itemNameEl = this.els.body.element.querySelector('.qb-Body_Title')

    return {
      itemId: formColumn?.dataset.productId || recommendationContext.itemId,
      itemName:
        itemNameEl?.textContent?.trim() || recommendationContext.itemName,
      variationId: variationInput?.value || undefined,
    }
  }

  handleClose () {
    this.externalEls.modal.element.close()
  }

  get client () {
    return window.theme?.constructorIo?.client || null
  }

  get tracker () {
    return this.client?.tracker || null
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
